import { Popover } from "antd";

const LinksListPopoverWrapper = ({ content, children }) => {
  if (!content) return children;

  return (
    <Popover content={content} placement="left">
      {children}
    </Popover>
  );
};

export default LinksListPopoverWrapper;
